import React from 'react'
import { useParams } from 'react-router-dom';
import Container from '../../components/container';
import HeaderHome from '../../components/header';
import FooterHome from '../../components/footer';
import '../../assets/styles/scss/pages/_jobHistory.scss'
import Content from './content';
import { HomeContextProvider } from '../home/context/homeContext';

const JobHistory = () => {
    const { email } = useParams();
    console.log('email', email)
    return (
        <Container>
            <header className='div-header'>
                <HeaderHome />
            </header>
            <div className="job-history-content relative" >
                <div className='container job-content mx-auto mt-10' >
                    <div className="title">ประวัติการสมัครงาน</div>
                    <Content />
                </div>
            </div>
            <footer>
                <FooterHome />
            </footer>
        </Container>
    )
}

export default JobHistory